import { ExportSection } from '../types';
import { mergeExportColumns } from './mergeExportColumns';

export const mergeExportSections = (
  currentSections: ExportSection[],
  nextSections: ExportSection[]
): ExportSection[] =>
  nextSections.map((nextSection) => {
    const existingSection = currentSections.find(
      (section) => section.id === nextSection.id
    );

    if (!existingSection) {
      return nextSection;
    }

    // Preserve user choices when dataset definitions are refreshed by subset loading.
    const columns = mergeExportColumns(
      nextSection.columns,
      existingSection.columns
    );

    if (nextSection.kind === 'master') {
      return {
        ...nextSection,
        columns,
        enabled: existingSection.enabled,
      };
    }

    return {
      ...nextSection,
      columns,
      enabled: existingSection.enabled,
      rows: existingSection.rows.length
        ? existingSection.rows
        : nextSection.rows,
      dataAvailable: existingSection.dataAvailable || nextSection.dataAvailable,
    };
  });
